'use strict';

import { CoreRepository } from '../CoreRepository';
import { UserSoaStatus } from '../../Entities/User/UserSoaStatus';
import { UserSoaStatusCollection } from '../../Collections/User/UserSoaStatusCollection';

export class UserSoaStatusRepository extends CoreRepository {
  public createIndSoaStatus(indId, payload: object = {}) {
    return this.webAPI.createIndSoaStatus(indId, payload).then((response) => {
      const userSoaStatus = new UserSoaStatus();
      userSoaStatus.hydrate(response);

      return userSoaStatus;
    });
  }

  public getIndSoaStatus(indId, options: object = {}, criteria: object = null) {
    if (!options) {
      options = {};
    }

    if (criteria) {
      options['criteria'] = criteria;
    }

    return this.webAPI.getIndSoaStatus(indId, options).then((response) => {
      const collection = new UserSoaStatusCollection();

      response.data.forEach((collectionItemData) => {
        const collectionItem = new UserSoaStatus();
        collectionItem.hydrate(collectionItemData);

        collection.addItem(collectionItem);
      });

      collection.setOffset(response.offset);
      collection.setLimit(response.limit);
      collection.setTotal(response.total);

      return collection;
    });
  }
  /*
    public getUserSoaStatuss(options: object = {}, criteria: object = null){
        if( !options )
        {
        options = {};
        }

        if( criteria )
        {
        options['criteria'] = criteria;
        }

        return this.webAPI.get(options)
        .then( response => {
            let collection = new UserSoaStatusCollection();

            response.data.forEach(collectionItemData => {
            let collectionItem = new UserSoaStatus();
                collectionItem.hydrate(collectionItemData);

            collection.addItem(collectionItem);
            });

            collection.setOffset(response.offset);
            collection.setLimit(response.limit);
            collection.setTotal(response.total);

            return collection;
        });

    }
    */

  /*
    public getUserSoaStatus(options: object = null){
        if( !options )
        {
        options = {};
        }

        return this.webAPI.getUserSoaStatus(options)
        .then( response => {
            if( !response )
            {
            return false;
            }

            let UserSoaStatus = new UserSoaStatus();
            UserSoaStatus.hydrate(response);

            return UserSoaStatus;
        });
    }

   

    public updateUserSoaStatus(payload: object = {}){  
        return this.webAPI.updateUserSoaStatus(payload)
        .then( response => {
            let UserSoaStatus = new UserSoaStatus();
            UserSoaStatus.hydrate(response);

            return UserSoaStatus;
        });
    }

    public removeUserSoaStatus( ){
        return this.webAPI.removeUserSoaStatus()
        .then( response => {
            return response;
        });
    }
    */
}
